import { lazyVue } from "@/utils";
export default [
  {
    path: "/bigScreen",
    name: "bigScreen",
    title: "",
    component: lazyVue("bigScreen/index"),
    meta: {
      title: "欢迎页",
      name: "bigScreen",
      showBar: false,
      isKeepAlive: false
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/bigScreen/index.js